import React from "react";

import { Box, useTheme } from "@origin-digital/ods-core";

import { IconSearch } from "@origin-digital/ods-icons";
import styled from "styled-components";
import { TrackedButton } from "./TrackedButton";

const ButtonWrapper = styled.div(() => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "right",
}));

const ButtonContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  width: "auto",

  [theme.breakpoints.up("lg")]: {
    width: "auto",
    marginRight: 0,
  },

  "& button": {
    display: "flex",
    position: "relative",
    alignItems: "center",
    justifyContent: "center",
    width: "auto",
    padding: 0,

    [theme.breakpoints.up("lg")]: {
      width: "auto",
      position: "relative",

      "& svg": {
        width: theme.shape.iconSizes.xxsmall,
        height: theme.shape.iconSizes.xxsmall,
      },
    },
  },
}));

export const helpSupportButtonMetadata = {
  dataId: "action-bar-help-button",
  name: "help",
  title: "Help",
  ariaLabel: "Go to Help and Support page",
};

export const HelpSupportButton = ({
  onClick,
  presentation,
  secondaryColor = false,
  showLabel = true,
}: {
  onClick?: () => void;
  presentation: "mobile" | "desktop";
  secondaryColor?: boolean;
  showLabel?: boolean;
}) => {
  const { ariaLabel, dataId, name, title } = helpSupportButtonMetadata;
  const { palette } = useTheme();

  return (
    <ButtonWrapper>
      <ButtonContainer
        borderRadius="large"
        backgroundColor={
          secondaryColor
            ? palette.backgroundColor.tertiary
            : palette.backgroundColor.grey
        }
        data-id={`${presentation}-help-support-button`}
      >
        <TrackedButton
          aria-label={ariaLabel}
          color="secondaryB"
          data-id={dataId}
          icon={<IconSearch variant="solid" color="neutralDark" />}
          id={`${name}-button`}
          muiProps={{
            style: {
              minWidth: 0,
              paddingLeft: "12px",
              paddingRight: "12px",
            },
            sx: showLabel
              ? undefined
              : {
                  "&&& .MuiButton-startIcon": {
                    marginLeft: 0,
                    marginRight: 0,
                  },
                  "&&& .MuiButton-startIcon svg": {
                    fontSize: "16px",
                  },
                },
          }}
          onClick={onClick}
          size={presentation === "mobile" ? "xsmall" : "small"}
          trackingLabel={title}
          variant="text"
        >
          {showLabel ? title : null}
        </TrackedButton>
      </ButtonContainer>
    </ButtonWrapper>
  );
};
